import { render, staticRenderFns } from "./LandingPageIndividuals.vue?vue&type=template&id=67f37094"
import script from "./LandingPageIndividuals.vue?vue&type=script&lang=js"
export * from "./LandingPageIndividuals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports